import Routes from "routing/Routes";
import { TELEMETRY_EVENT_TYPE } from "logic/telemetry/Constants";
import AppConfig from "util/AppConfig";
export const PAGE_NAV_TITLE = "Collectors";
const bindings = AppConfig.isFeatureEnabled("collectors") ? {
  pageNavigation: [
    {
      description: PAGE_NAV_TITLE,
      children: [
        { description: "Overview", path: Routes.SYSTEM.COLLECTORS.OVERVIEW, exactPathMatch: true },
        { description: "Fleets", path: Routes.SYSTEM.COLLECTORS.FLEETS },
        { description: "Instances", path: Routes.SYSTEM.COLLECTORS.INSTANCES },
        { description: "Deployment", path: Routes.SYSTEM.COLLECTORS.DEPLOYMENT },
        { description: "Settings", path: Routes.SYSTEM.COLLECTORS.SETTINGS }
      ]
    }
  ],
  entityCreators: [
    {
      id: "Fleet",
      title: "Create fleet",
      path: Routes.SYSTEM.COLLECTORS.FLEETS_NEW,
      telemetryEvent: {
        type: TELEMETRY_EVENT_TYPE.COLLECTORS.FLEET.CREATE_OPENED,
        section: "collectors",
        actionValue: "create-fleet-button"
      }
      // TODO we don't have permissions yet      permissions: 'fleets:create',
    }
  ]
} : {};
export default bindings;
